(function ($) {

    $.fn.navStrip = function (opts) {

        var init = function () {

            opts = $.extend({}, $.fn.navStrip.defaultOptions, opts);

            var _this = this;
            $(this).addClass('navstrip');

            var prev = $('<div class="btn btn-link scroll-left"><i class="icon-angle-left"></i></div>');
            var next = $('<div class="btn btn-link scroll-right"><i class="icon-angle-right"></i></div>');

            $(this).prepend(prev).append(next);

            $('nav', this).animate({scrollLeft: this.scrollPos + 'px'}, 0);

            function setPos(dir){
                var left = $('nav', _this).scrollLeft();
                $('nav', _this).animate({scrollLeft: left + _this.dist * dir + "px"}, 400, function () {
                    var newleft = $('nav', _this).scrollLeft();
                    var showPrev = newleft > 0;
                    var showNext = ($('nav .navbar-nav', _this).width() - newleft - $('nav', _this).width() - 30) > 0;
                    prev.toggleClass('disabled', !showPrev);
                    next.toggleClass('disabled', !showNext);
                });

                return left;
            }

            prev.click(function (e) {
                e.stopPropagation();
                setPos(-1);
            });

            next.click(function (e) {
                e.stopPropagation();
                setPos(1);
            });

            setPos(0);
        };

        var ret = [];


        this.each(function () {

            this.dist = 240;
            this.scrollPos = 0;

            init.call(this);

            var obj = this;
            ret.push({obj: obj});
        });
    };


})(jQuery);
